const user = {
  state: {
    userDetal: {},
    accessToken: "",
    appToken: "",
    supInfo: {},
    loginInfo: {},
    agentId: "",
    catalogList: [], //导购类目列表
    isPortal: true //当前页面是否是首页
  },

  mutations: {
    SET_ACCESS_TOKEN: (state, token) => {
      state.accessToken = token;
    },
    SET_APP_TOKEN: (state, token) => {
      state.appToken = token;
    },
    SET_USER_DETAL: (state, obj) => {
      state.userDetal = obj;
    },
    SET_USER_ID: (state, userId) => {
      state.userId = userId;
    },
    SET_SUP_INFO: (state, obj) => {
      state.supInfo = obj;
    },
    SET_LOGIN_INFO: (state, obj) => {
      state.loginInfo = obj;
    },
    SET_AGENT_ID: (state, obj) => {
      state.agentId = obj;
    },
    SET_CATALOG_LIST: (state, list) => {
      state.catalogList = list;
      console.log(state.catalogList, "state");
    },
    SET_IS_PORTAL: (state, flag) => {
      state.isPortal = flag;
    }
  },

  actions: {
    setsupinfo({ commit }, response) {
      commit("SET_SUP_INFO", response);
    },
    setLoginInfo({ commit }, response) {
      commit("SET_LOGIN_INFO", response);
    },
    setAgentId({ commit }, response) {
      commit("SET_AGENT_ID", response);
    }
  },
  getters: {
    getLoginInfo: state => {
      return state.loginInfo;
    },
    getAccessToken: state => {
      return state.accessToken;
    },
    getAgentId: state => {
      return state.agentId;
    },
    getCatalogList: state => {
      return state.catalogList;
    }
  }
};

export default user;
